import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '&.reply': {
      marginBottom: theme.spacing(2),
    },
    '& .comment': {
      '&-input': {
        width: '100%',
      },
      '&-actions': {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
  },
  input: {
    ...theme.typography.body2,
  },
  btn: {
    ...theme.typography.caption,
    textTransform: 'none',
  },
}));

export default styles;
